import React, { ChangeEvent, useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import './styles.css'
import FilterSelect from '../../../components/FilterSelect';
import { TextField, Button } from '@mui/material';
import { getCidades, getEnfermeirosPlanoMais, getEspecAgendOnLineTele, getEspecialidadeGuiaEncaminhamentoPlanoMais, getPrestadoresPlanoMais } from '../../../services/SaudeOnlineService';
import { TypeOfAppointmentEnum } from '../../../interfaces/enum/TypeOfAppointmentEnum';
import { GuiaMedicoComAgendamento } from '../../../interfaces/entities/GuiaMedicoComAgendamento';
import { Doctor } from '../../../interfaces/entities/Doctor';
import { typesOfAppointmentDefault } from './defaultStates';
import { sxButton, sxTextField, sxTextFieldContrast } from './sxProps';
import { FilterProps } from '../../../interfaces/props/SaudeOnline/FilterProps';
import { FilterInterface } from '../../../interfaces/entities/FilterInterface';
import LoadingApp from '../../../components/LoadingApp';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

function Filter(props: FilterProps) {

  const [typesOfAppointment, setTypesOfAppointment] = useState<FilterInterface[]>(typesOfAppointmentDefault);
  const [typeOfAppointment, setTypeOfAppointment] = useState<string>('');
  const [specialties, setSpecialties] = useState<FilterInterface[]>([]);
  const [cities, setCities] = useState<FilterInterface[]>([]);
  const [referralDoctors, setReferralDoctors] = useState<FilterInterface[]>([]);
  const [referralNurses, setReferralNurses] = useState<FilterInterface[]>([]);
  const [specialization, setSpecialization] = useState<string>('');
  const [city, setCity] = useState<string>('');
  const [doctor, setDoctor] = useState<string>('');
  const [eraseSpec, setEraseSpec] = useState<boolean>(false);
  const [eraseType, setEraseType] = useState<boolean>(false);
  const [eraseCity, setEraseCity] = useState<boolean>(false);
  const [eraseDoc, setEraseDoc] = useState<boolean>(false);
  const [eraseNurse, setEraseNurse] = useState<boolean>(false);
  const [showLoading, setShowLoading] = useState<boolean>(false);

  const accessibility = useAccessibility();

  useEffect(() => {
    const handleInPersonAppointment = async () => {
      setShowLoading(true);
      let especResult: FilterInterface[] | null = null;
      let cityResult: FilterInterface[] | null = null;
      let referralDoctorsResult: FilterInterface[] | Doctor[] | null = null;
      let referralNursesResult: FilterInterface[] | Doctor[] | null = null;
      if (props.userType === 'N') {
        especResult = await getEspecAgendOnLineTele();
        cityResult = await getCidades();
      }

      if (props.userType === 'S') {
        especResult = await getEspecialidadeGuiaEncaminhamentoPlanoMais();
        referralDoctorsResult = await getPrestadoresPlanoMais();
        onDocsResult(referralDoctorsResult || [])
        referralNursesResult = await getEnfermeirosPlanoMais();
        onNursesResult(referralNursesResult || [])
      }

      if (especResult !== null) {
        const espec: FilterInterface[] = especResult;
        espec.unshift({ id: '-1', descricao: 'Em qualquer especialidade' })
        setSpecialties(espec);
      }

      if (cityResult !== null) {
        const citiesList: FilterInterface[] = cityResult;
        citiesList.unshift({ id: '-1', descricao: 'Em qualquer cidade' })
        setCities(cityResult)
      }
      setShowLoading(false);
    }

    const handleTeleservice = async () => {
      setShowLoading(true);
      let especResult: FilterInterface[] | null = null;
      let referralDoctorsResult: FilterInterface[] | Doctor[] | null = null;
      let referralNursesResult: FilterInterface[] | Doctor[] | null = null;

      if (props.userType === 'N') {
        especResult = await getEspecAgendOnLineTele();
      }

      if (props.userType === 'S') {
        especResult = await getEspecialidadeGuiaEncaminhamentoPlanoMais();
        referralDoctorsResult = await getPrestadoresPlanoMais();
        onDocsResult(referralDoctorsResult || [])
        referralNursesResult = await getEnfermeirosPlanoMais();
        onNursesResult(referralNursesResult || [])
      }

      if (especResult !== null) {
        setSpecialties(especResult)
        setCities([])
      }

      if (especResult !== null) {
        const espec: FilterInterface[] = especResult;
        espec.unshift({ id: '-1', descricao: 'Em qualquer especialidade' })
        setSpecialties(espec);
      }

      setShowLoading(false);
    }

    setSpecialization('');
    setCity('');
    setDoctor('');
    setEraseSpec(!eraseSpec);
    setEraseCity(!eraseCity);

    switch (typeOfAppointment) {
      case TypeOfAppointmentEnum.Presencial:
        handleInPersonAppointment();

        break;
      case TypeOfAppointmentEnum.Teleatendimento:
        handleTeleservice();
        break;

      default:
        break;
    }
  }, [typeOfAppointment]);

  useEffect(() => {
    if (!specialization) return;
    
    if (props.userType === 'S') {
      const search: GuiaMedicoComAgendamento = {
        especialidade: specialization,
        tipoAtend: typeOfAppointment,
        dtDispon: new Date(),
        start: "0",
        latitude: 0,
        longitude: 0,
        limit: "999",
      }

      switch (typeOfAppointment) {
        case TypeOfAppointmentEnum.Presencial:
          props.handleFilter(search, 'Presencial');

          break;
        case TypeOfAppointmentEnum.Teleatendimento:
          props.handleFilter(search, 'Telemedicina');
          break;
      }

    }
  }, [specialization]);


  const onDocsResult = (referralDocsResult: Doctor[]) => {
    const array: FilterInterface[] = [];

    referralDocsResult.forEach((referralDocs) => {
      array.push({
        id: referralDocs.idPessoa,
        descricao: referralDocs.nomePessoa
      })
    })

    setReferralDoctors(array);
  }

  const onNursesResult = (referralNursesResult: Doctor[]) => {
    const array: FilterInterface[] = [];
    array.unshift({ id: '-1', descricao: 'Todos(as)' })
    referralNursesResult.forEach((referralNurses) => {
      array.push({
        id: referralNurses.idPessoa,
        descricao: referralNurses.nomePessoa
      })
    })
    setReferralNurses(array);
  }

  const handleType = (value: string) => {
    setTypeOfAppointment(value)
  }

  const handleSpecialization = (value: string) => {
    setSpecialization(value)

    if (props.userType === 'S') {
      setEraseDoc(!eraseDoc);
      setEraseNurse(!eraseNurse);
    }
  }

  const handleCity = (value: string) => {
    setCity(value.toString())
  }

  const handleDoctor = (event: ChangeEvent<HTMLInputElement | HTMLInputElement>) => {
    setDoctor(event.target.value);
  };

  const handleFilter = () => {
    if (specialization !== '' || doctor !== '' || city !== '') {

      const search: GuiaMedicoComAgendamento = {
        cidade: city,
        especialidade: specialization,
        nome: doctor,
        tipoAtend: typeOfAppointment,
        dtDispon: new Date(),
        start: '0',
        latitude: 0,
        longitude: 0,
        limit: '999',
      }

      if (specialization === '' || specialization === '-1') {
        delete search.especialidade;
      }

      if (city === '' || city === '-1') {
        delete search.cidade;
      }

      if (doctor === '') {
        delete search.nome;
      }

      switch (typeOfAppointment) {
        case TypeOfAppointmentEnum.Presencial:
          props.handleFilter(search, 'Presencial');

          break;
        case TypeOfAppointmentEnum.Teleatendimento:
          props.handleFilter(search, 'Telemedicina');
          break;
      }
    } else {
      props.handleInvalidSearch();
    }

  }

  const handleRefferalDoc = (value: string) => {
    switch (typeOfAppointment) {
      case TypeOfAppointmentEnum.Presencial:
        props.handlePersonalFilter(value, 'doctor', 'Presencial');

        break;
      case TypeOfAppointmentEnum.Teleatendimento:
        props.handlePersonalFilter(value, 'doctor', 'Telemedicina');
        break;
    }

    setEraseSpec(!eraseSpec);
    setEraseNurse(!eraseNurse);
  }

  const handleRefferalNurse = (value: string) => {
    switch (typeOfAppointment) {
      case TypeOfAppointmentEnum.Presencial:
        props.handlePersonalFilter(value, 'nurse', 'Presencial');

        break;
      case TypeOfAppointmentEnum.Teleatendimento:
        props.handlePersonalFilter(value, 'nurse', 'Telemedicina');
        break;
    }

    setEraseSpec(!eraseSpec);
    setEraseDoc(!eraseDoc);
  }

  const eraseFilters = () => {
    setSpecialization('');
    setCity('');
    setDoctor('');
    setEraseSpec(!eraseSpec);
    setEraseCity(!eraseCity);
    setEraseType(!eraseType);
  }

  return (
    <div className='filter-holder'>
      <LoadingApp showLoading={showLoading} />
      <h1 className='filter-title' style={accessibility.textStyleAccessibility}><FontAwesomeIcon icon={faFilter} />&nbsp;Filtrar resultados</h1>
      <div className={props.userType === 'S' ? "filter-row-agendamento" : "filter-row"}>
        <div className={props.userType === 'S' ? "filter-option-agendamento" : "filter-option-guia-medico"}>
          <FilterSelect title='Tipo de atendimento' options={typesOfAppointment} disabled={false} handleChange={handleType} erase={eraseType} />
        </div>
        <div className={props.userType === 'S' ? "filter-option-agendamento" : "filter-option-guia-medico"}>
          <FilterSelect title='Especialidade' options={specialties} disabled={typeOfAppointment === '' ? true : false} handleChange={handleSpecialization} erase={eraseSpec} />
        </div>
        {props.userType !== 'S' &&
          <div className="filter-option-guia-medico">
            <FilterSelect title='Cidade' options={cities} disabled={typeOfAppointment === '' ||
              typeOfAppointment === TypeOfAppointmentEnum.Teleatendimento
              ? true : false}
              handleChange={handleCity}
              erase={eraseCity} />
          </div>
        }
        {props.userType === 'S' &&
          <>
            <div className="filter-option-agendamento">
              <FilterSelect title='Médico(a) de referência' options={referralDoctors} disabled={typeOfAppointment === '' ? true : false} handleChange={handleRefferalDoc} erase={eraseDoc} />
            </div>
            <div className="filter-option-agendamento">
              <FilterSelect title='Enfermeiro(a) de referência' options={referralNurses} disabled={typeOfAppointment === '' ? true : false} handleChange={handleRefferalNurse} erase={eraseNurse} />
            </div>
          </>

        }
      </div>
      <div className="filter-row">

        {props.userType !== 'S' &&
          <div className="schedule-filter-textfield">
          <label htmlFor="outlined-basic" className='select-label' style={accessibility.textStyleAccessibility}>Pesquisar nome do(a) médico(a) (opcional)</label>
            <div className="search-holder">
              <TextField
                id="outlined-basic"
                variant="outlined"
                onChange={handleDoctor}
                value={doctor}
                sx={sxTextField}
                fullWidth
                disabled={typeOfAppointment === ''}
                InputProps={{
                  style: {
                    ...accessibility.contrastStyle
                  },
                }}
                inputProps={{style: {color: accessibility.contrastMode ? 'white' : ''}}}
              />
              <div className="search-holder-button">
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleFilter}
                  sx={sxButton}
                  style={{...accessibility.buttonStyleAccessibility, ...accessibility.buttonTextStyleAccessibility}}
                  fullWidth>
                  BUSCAR
                </Button>
              </div>
              <div className="clean-filter-button-holder-agendar">
                <button className="clean-filter-button" onClick={eraseFilters}>
                  <u style={accessibility.textStyleAccessibility}>Limpar filtros</u>
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default Filter